import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  Community,
  CommunityStatus,
  UserCommunity,
} from '@/models/community.model';
import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import CommunityForm from '../municipalities/CommunityForm.vue';
import { NEW_ID } from '@/util/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommunitiesList',
  setup(__props) {

const store = useStore<ShiftCMSState & { us: UsersState }>();

const communities = computed<Community[]>(() => store.state.us.communities);

const update = () => {
  store.dispatch(UsersActions.GetCommunitiesList);
};

const addCommunity = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(CommunityForm),
    data: {
      id: NEW_ID,
      name: '',
      groupUrl: '',
      status: CommunityStatus.Pending,
      municipality: null,
      ambassador: null,
      members: [],
    },
  });
};

function editCommunity(evt: Event, { item }: { item: Community }) {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(CommunityForm),
    data: item,
  });
}

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const headers = [
  { title: 'ID', key: 'id', width: '5%' },
  { title: 'Municipality', key: 'municipality.name', width: '15%' },
  { title: 'Name', key: 'name', width: '15%' },
  { title: 'Ambassador', key: 'ambassador', width: '15%' },
  { title: 'Members', key: 'members', width: '15%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Communities", -1)),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editCommunity,
        headers: headers,
        items: communities.value,
        hover: ""
      }, {
        "item.ambassador": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value ? `${value.firstName} ${value.lastName}` : '-'), 1)
        ]),
        "item.members": _withCtx(({ value, item }) => [
          _createVNode(_component_v_tooltip, { text: "These users are confirmed members" }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_chip, _mergeProps({
                class: "mr-2",
                color: "success",
                density: "compact"
              }, props), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(value.filter((v) => !v.isTemporary).length), 1)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 2
          }, 1024),
          (value.filter((v) => v.isTemporary).length)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 0,
                text: "These users have not confirmed membership"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_chip, _mergeProps({
                    color: "secondary",
                    class: "mr-2",
                    density: "compact"
                  }, props), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(value.filter((v) => v.isTemporary).length), 1)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (item.userCount !== 0)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 1,
                text: "This is the membership count shown in the app"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_chip, _mergeProps({
                    class: "mr-2",
                    color: "info",
                    density: "compact"
                  }, props), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.userCount), 1)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addCommunity,
        color: "success"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Community")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})